import React, { Component } from "react";
import GlobalLayout from "../../../components/layouts/layout-global";
import SectionDefault from "../../../components/sections/section-default";
import TrainingSection from "../../../components/training/training-section";
import LinkList from "../../../components/quick-links/link-list";
import LinkListItem from "../../../components/quick-links/link-list-item";
import SEO from "../../../components/seo";

function TrainingLink(props) {
  return (
    <LinkListItem
      {...props}
      linkStyle={{ fontWeight: 500, fontSize: 16 }}
      elementStyle="uk-margin-remove-top uk-margin-bottom"
    />
  );
}

export const Head = ({ location }) => (
  <SEO
    title="Clinical training"
    // prettier-ignore
    keywords={['NACC', 'UDS', 'neuropsychological', 'NACC', 'Alzheimer\'s', 'ADRC', 'dementia', 'MCI', 'degeneration', 'research', 'data', 'NIA', 'NIH', 'database', 'neuropathology', 'LBD', 'FTLD', 'neurology', 'age', 'cognitive', 'genetics', 'GWAS', 'APOE', 'gerontology']}
    description="Training for administering the UDS, UDS 3, T-cog, Down Syndrome Module, and FTLD Module."
    pathname={location.pathname}
  />
);

class FtldModuleTraining extends Component {
  render() {
    return (
      <GlobalLayout location={this.props.location}>
        <SectionDefault heading="Clinical training">
          {/* UDS */}
          <TrainingSection id="uds3-training" header="Training for administering the UDS">
            <LinkList>
              <TrainingLink
                to="/nacc-collaborations/uds4-updates"
                text="UDSv4 Tools and Resources"
                caption="UDSv4 Updates, Resources, and Information"
              />
            </LinkList>
            <LinkList title={<h3 className="uk-h4 uk-margin-small-bottom">Other UDS training materials</h3>}>
              <TrainingLink
                to="https://knightadrc.wustl.edu/cdr-training-application/"
                text="Knight ADRC Public CDR&reg; Training"
                caption="Form B4: CDR&reg; (links to Washington University in St. Louis)"
                external
              />
              <TrainingLink
                to="/data-collection/training/npiq-certification"
                text="NPI-Q Interviewer Certification Module"
                caption="Form B5: NPI-Q Interviewer Certification Module"
              />
            </LinkList>
          </TrainingSection>

          {/* UDS 3 */}
          <TrainingSection id="uds3" header="UDS 3">
            <LinkList>
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ClinWebinar.final.mp4"
                text="Clinician Walkthrough Webinar, Forms B8 and D1"
                caption="Webinar recording related to Form B8: Neurological Examination Findings and Form D1: Clinician Diagnosis"
                external
              />
              <TrainingLink
                to="/data-collection/training/uds-3/"
                text="Questions and answers about UDS3"
                caption="Guidance for general, Neuropsychological battery and and Initial Visit Packet."
              />
            </LinkList>
            <TrainingLink
              to="/data-collection/training/tcog-training"
              text="Questions and answers about the new Telephone Follow-up Packet"
              caption="Guidance for general and Neuropsych test administration"
            />
          </TrainingSection>

          {/* Down Syndrom Module Training */}
          <TrainingSection id="dsm-training" header="Down Syndrome Module Training">
            <TrainingLink
              to="https://files.alz.washington.edu/documentation/dsm-abc-ds-case-consensus-process.docx"
              text="ABC-DS Case Consensus Process"
              caption="For reference, Alzheimer's Biomarkers Consortium — Down Syndrome (ABC-DS) case consensus process for
                determination of Alzheimer's Disease clinical status."
              external
            />
            <TrainingLink
              to="https://s3-us-west-2.amazonaws.com/files.alz.washington.edu/documentation/dsm-nacc-consensus-conference-form.docx"
              text="Consensus Conference Form"
              caption="Companion case consensus form that can be used alongside the recommended guidelines for case consensus
                outlined in the DS-Module guidebooks."
              external
            />
            <TrainingLink
              to="https://www.alz.washington.edu/MEMBER/portal/training/ds-mod-videos.html"
              text="Training videos"
              caption="Neuropsycological test administration guidance videos (a NACC account is mandatory to access this section)."
              external
            />
          </TrainingSection>

          {/* FTLD */}
          <TrainingSection id="ftld3-training" header="Training for administering the FTLD Module">
            <LinkList title={<h3 className="uk-h4 uk-margin-small-bottom">Essential FTLD reference documents</h3>}>
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld3-ivp-guidebook.pdf"
                text=" Coding guidebook — Initital visit (pdf)"
                caption="Detailed, annotated explanations of each form on an item-level basis, with instructions, operational
                definitions, and references"
                external
              />
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld3-fvp-guidebook.pdf"
                text="Coding guidebook — Follow-up visit (pdf)"
                caption="Detailed, annotated explanations of each form on an item-level basis, with instructions, operational
                definitions, and references"
                external
              />
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld3-np-instructions.pdf"
                text="Instructions for the neuropsychological battery (pdf)"
                caption="Detailed instructions for administration and scoring of the neuropsychological tests"
                external
              />
            </LinkList>
            <LinkList
              title={
                <h3 className="uk-h4 uk-margin-small-bottom">
                  Presentations from the 2011 FTLD Module training meeting
                </h3>
              }
            >
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld-overview.pdf"
                text="Overview of the FTLD Module (PDF)"
                caption="Presentation by David Knopman, MD, Chair of the ADRC FTLD working group"
                external
              />
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld-family-history.pdf"
                text="The family history/genetics form: A3F (PDF)"
                caption="Presentation by NACC Director Walter A. Kukull, PhD"
                external
              />
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld-sandyw.pdf"
                text="Neuropsych battery: Language tasks (PDF)"
                caption="Presented by Sandra Weintraub, PhD"
                external
              />
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld-kramer.pdf"
                text="Neuropsych battery: Visuospatial tasks (PDF)"
                caption="Presented by Joel Kramer, PsyD"
                external
              />
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld-rankin.pdf"
                text="Neuropsych battery: Behavioral assessments (Forms C2F – C6F) (PDF)"
                caption="Presented by Kate Rankin, PhD"
                external
              />
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld-neuroex.pdf"
                text="Clinical forms: B3F and B9F (PDF)"
                caption="Supplemental neurological exam; bvFTD and PPA diagnoses. Presented by David Knopman, MD, Chair of the
                ADRC FTLD working group"
                external
              />
              <TrainingLink
                to="https://files.alz.washington.edu/documentation/ftld-mesulam.pdf"
                text="Clinical form: B9F (PDF)"
                caption=" Overview of the PPA diagnosis. Presented by M.-Marsel Mesulam, MD; see also link to accompanying video,
                below"
                external
              />
            </LinkList>
          </TrainingSection>
        </SectionDefault>
      </GlobalLayout>
    );
  }
}

export default FtldModuleTraining;
